module.exports = __webpack_public_path__ + "img/JSB_FINANCING.829db0e4.png";